import React from "react";

import TeamCard from "./TeamCard";

const Teams = ({ teams }) => teams.map((team) => {
  return <TeamCard key={team.uuid} team={team} />;
});

export default Teams;
